import { Delta } from 'quill/core'

export const toDeltaFormat = (raw: any) => {
  if (raw === null || raw === '') return ''

  return new Delta(raw)
}
